import {Divider, Stack, Typography} from '@mui/material';
import React from 'react';

import {CTAButtonFixed} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {Filter} from 'presentation/components/Filter';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {useAppointmentsFilterHeader} from './hooks/useAppointmentsFilterHeader';
import {FilterHeaderProps} from './types';

const {filter: filterText} = translations['pt-br'].commons;

const {newAppointment} = translations['pt-br'].privateFlow.myAppointments;

export function AppointmentsFilterHeader({handleNewAppointment, totalCount}: FilterHeaderProps) {
	const {
		shouldHideComponent,
		appointmentCountText,
		hasFilters,
		handleOpenDrawer,
		listFilters,
		openDrawerState,
		handleCloseDrawer,
		isMobile,
		theme,
		handleClearFilter,
		handleApplyFilter,
		isTablet,
		bookingType,
		shouldShowAppointmentButton,
	} = useAppointmentsFilterHeader(totalCount);

	if (shouldHideComponent) return null;

	return (
		<Stack flexDirection={isTablet ? 'column-reverse' : 'column'} marginBottom={2} gap={2}>
			<Stack direction="row" justifyContent={'space-between'} alignItems={'center'}>
				<Typography fontSize={'1rem'} sx={{color: theme.colors.light.text.secondary}}>
					{appointmentCountText}
				</Typography>
				<Stack direction={'row'} alignItems={'center'} gap={1}>
					{!hasFilters ? null : (
						<Stack direction={'row'} alignItems={'center'} gap={1}>
							<Filter.Button
								onClick={handleOpenDrawer}
								count={bookingType ? 1 : undefined}>
								{filterText}
							</Filter.Button>
							<Drawer.Root
								open={openDrawerState}
								onOpen={handleOpenDrawer}
								onClose={handleCloseDrawer}
								width={'600px'}>
								<Drawer.Header title="Filtros" onClose={handleCloseDrawer} />
								<Drawer.ContentListByCategory categoryList={listFilters} />
								<Drawer.Footer
									firstButtonOnClick={handleClearFilter}
									secondButtonOnClick={handleApplyFilter}
								/>
							</Drawer.Root>
							{!shouldShowAppointmentButton || isMobile ? null : (
								<Divider orientation="vertical" sx={{width: 2, height: 30}} />
							)}
						</Stack>
					)}
					{shouldShowAppointmentButton ? (
						<CTAButtonFixed.Root>
							<CTAButtonFixed.Action
								fullWidth
								size={isMobile ? 'large' : 'medium'}
								variant="contained"
								endIcon={<Icon name="event-filled" />}
								onClick={handleNewAppointment}>
								{newAppointment}
							</CTAButtonFixed.Action>
						</CTAButtonFixed.Root>
					) : null}
				</Stack>
			</Stack>
		</Stack>
	);
}
